import { useCallback, useState } from 'react';
import { BookingService } from '../services/BookingService';

interface Enquiry {
  name: string;
  email: string;
  phone: string;
  company?: string;
  enquiryType: 'tour' | 'membership' | 'enterprise' | 'general';
  message: string;
}

// Custom hook following MVVM pattern - ViewModel layer
export const useBookingActions = () => {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const handleBookTour = useCallback(async () => {
    try {
      await BookingService.bookTour();
    } catch (error) {
      console.error('Failed to book tour:', error);
    }
  }, []);

  const handleStartMembership = useCallback(async () => {
    try {
      await BookingService.startMembership();
    } catch (error) {
      console.error('Failed to start membership:', error);
    }
  }, []);

  const handleContactSales = useCallback(async () => {
    try {
      await BookingService.contactSales();
    } catch (error) {
      console.error('Failed to contact sales:', error);
    }
  }, []);

  const handleLearnMore = useCallback(() => {
    // Scroll to features or navigate
    document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const handleEnquirySubmit = useCallback(async (enquiry: Enquiry) => {
    try {
      await BookingService.submitEnquiry(enquiry);
      setShowEnquiryForm(false);
    } catch (error) {
      console.error('Failed to submit enquiry:', error);
    }
  }, []);

  const openEnquiryForm = useCallback(() => {
    setShowEnquiryForm(true);
  }, []);

  const closeEnquiryForm = useCallback(() => {
    setShowEnquiryForm(false);
  }, []);

  return {
    handleBookTour,
    handleStartMembership,
    handleContactSales,
    handleLearnMore,
    handleEnquirySubmit,
    openEnquiryForm,
    closeEnquiryForm,
    showEnquiryForm,
  };
};